import {
  Button,
  ButtonLink,
  FieldWrapper,
  Stack,
  TextInputFieldController,
} from '@fukuri-admins/ui/common';
import { useFormContext } from 'react-hook-form';
import { getUsersLink } from '~/utils/getLinks';
import { PaginatedSelect } from '../../../../../src/component/PaginatedSelect';
import type { ApiResponse, OptionType } from '../../../../../src/component/PaginatedSelect/type';

type Props = {
  isButtonDisabled: boolean;
  searchAction: (input: string, page: number) => Promise<ApiResponse>;
  onClientChange: (option: OptionType | null) => void;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

export const CreateActivationFormPresentation: React.FC<Props> = ({
  isButtonDisabled,
  searchAction,
  onClientChange,
  onSubmit,
}) => {
  const { formState } = useFormContext();
  const clientIdError = formState.errors.clientId;

  return (
    <form onSubmit={onSubmit}>
      <Stack direction='column' gap={24} width='466px'>
        <FieldWrapper
          htmlFor='clientId'
          labelType='required'
          labelText='利用企業'
          errorMessages={clientIdError?.message ? [String(clientIdError.message)] : undefined}
        >
          <PaginatedSelect
            searchAction={searchAction}
            placeholder='選択してください'
            isClearable={true}
            onChange={onClientChange}
          />
        </FieldWrapper>
        <TextInputFieldController
          name='quantity'
          fieldWrapperProps={{
            labelType: 'required',
            labelText: '追加人数',
          }}
          textInput={{
            type: 'number',
            placeholder: '追加人数を入力',
          }}
        />
        <Stack direction='row' gap={16}>
          <ButtonLink to={getUsersLink()} variant='outline' size='md'>
            キャンセル
          </ButtonLink>
          <Button type='submit' size='md' disabled={isButtonDisabled}>
            追加
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
